import { lazy } from 'react'
import generateRouterDetail from 'utils/helpers/generateRouterDetail'
import { directPutawayRolesRBAC as directPutawayOldRolesRBAC } from 'pages/DirectPutaway/rbac'
import { inboundTaskRBAC } from 'features/PurchaseOrder/pages/InboundTask/rbac'
import { inboundTaskDetailRBAC } from 'features/PurchaseOrder/pages/InboundTaskDetail/rbac'
import { inboundTaskCheckQtyRBAC } from 'features/PurchaseOrder/pages/InboundTaskCheckQty/rbac'
import { directPutawayRolesRBAC } from '../pages/DirectPutaway/rbac'
import { directPutawayDetailRolesRBAC } from '../pages/DirectPutawayDetail/rbac'
import {
  purchaseOrderCreateRBAC,
  purchaseOrderInboundHubRBAC,
  purchaseOrderInboundWarehouseRBAC,
} from '../pages/PurchaseOrder/rbac'
import { purchaseOrderDetailRolesRBAC } from '../pages/PurchaseOrderDetail/rbac'
import { purchaseOrderCheckQuantityRBAC } from '../pages/PurchaseOrderCheckQuantity/rbac'

type NamedRoutesType =
  | 'DirectPutawayOldRouter'
  | 'DirectPutawayRouter'
  | 'DirectPutawayDetailRouter'
  | 'InboundTaskRouter'
  | 'InboundTaskDetailRouter'
  | 'InboundTaskCheckQtyRouter'
  | 'PurchaseOrderCreateRouter'
  | 'PurchaseOrderInboundHubRouter'
  | 'PurchaseOrderInboundWarehouseRouter'
  | 'PurchaseOrderInboundMegahubRouter'
  | 'PurchaseOrderApprovalRouter'
  | 'PurchaseOrderDetailRouter'
  | 'PurchaseOrderCheckQuantityRouter'

type PathListsType =
  | '/dashboard/direct-put-away-old'
  | '/dashboard/direct-put-away'
  | '/dashboard/direct-put-away/:id'
  | '/dashboard/inbound-task'
  | '/dashboard/inbound-task/:id'
  | '/dashboard/inbound-task/check-quantity/:id'
  | '/dashboard/purchase-order/create-po'
  | '/dashboard/purchase-order/inbound-hub'
  | '/dashboard/purchase-order/inbound-warehouse'
  | '/dashboard/purchase-order/inbound-megahub'
  | '/dashboard/purchase-order/approval'
  | '/dashboard/purchase-order/detail/:id'
  | '/dashboard/purchase-order/check-quantity/:id'

type RouterInstanceType = RouterFeatureInterface<NamedRoutesType, PathListsType>

const DirectPutawayOldPage = lazy(() => import('pages/DirectPutaway'))
const DirectPutawayPage = lazy(() => import('../pages/DirectPutaway'))
const DirectPutawayDetailPage = lazy(() => import('../pages/DirectPutawayDetail'))
const InboundTaskPage = lazy(() => import('../pages/InboundTask'))
const InboundTaskDetailPage = lazy(() => import('../pages/InboundTaskDetail'))
const InboundTaskCheckQtyPage = lazy(() => import('../pages/InboundTaskCheckQty'))
const PurchaseOrderPage = lazy(() => import('../pages/PurchaseOrder'))
const PurchaseOrderDetailPage = lazy(() => import('../pages/PurchaseOrderDetail'))
const PurchaseOrderCheckQuantity = lazy(() => import('../pages/PurchaseOrderCheckQuantity'))

export const DirectPutawayOldRouter: RouterInstanceType = {
  name: 'DirectPutawayOldRouter',
  Component: DirectPutawayOldPage,
  path: '/dashboard/direct-put-away-old',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: directPutawayOldRolesRBAC.pageID,
  isDashboard: true,
}

export const DirectPutawayRouter: RouterInstanceType = {
  name: 'DirectPutawayRouter',
  Component: DirectPutawayPage,
  path: '/dashboard/direct-put-away',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: directPutawayRolesRBAC.pageID,
  isDashboard: true,
}

export const DirectPutawayDetailRouter: RouterInstanceType = {
  name: 'DirectPutawayDetailRouter',
  Component: DirectPutawayDetailPage,
  path: '/dashboard/direct-put-away/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: directPutawayDetailRolesRBAC.pageID,
  isDashboard: true,
}

export const InboundTaskRouter: RouterInstanceType = {
  name: 'InboundTaskRouter',
  Component: InboundTaskPage,
  path: '/dashboard/inbound-task',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: inboundTaskRBAC.pageID,
  isDashboard: true,
}

export const InboundTaskDetailRouter: RouterInstanceType = {
  name: 'InboundTaskDetailRouter',
  Component: InboundTaskDetailPage,
  path: '/dashboard/inbound-task/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: inboundTaskDetailRBAC.pageID,
  isDashboard: true,
}

export const InboundTaskCheckQtyRouter: RouterInstanceType = {
  name: 'InboundTaskCheckQtyRouter',
  Component: InboundTaskCheckQtyPage,
  path: '/dashboard/inbound-task/check-quantity/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: inboundTaskCheckQtyRBAC.pageID,
  isDashboard: true,
}

export const PurchaseOrderCreateRouter: RouterInstanceType = {
  name: 'PurchaseOrderCreateRouter',
  Component: PurchaseOrderPage,
  path: '/dashboard/purchase-order/create-po',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: purchaseOrderCreateRBAC.pageID,
  isDashboard: true,
}

export const PurchaseOrderInboundHubRouter: RouterInstanceType = {
  name: 'PurchaseOrderInboundHubRouter',
  Component: PurchaseOrderPage,
  path: '/dashboard/purchase-order/inbound-hub',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: purchaseOrderInboundHubRBAC.pageID,
  isDashboard: true,
}

export const PurchaseOrderInboundWarehouseRouter: RouterInstanceType = {
  name: 'PurchaseOrderInboundWarehouseRouter',
  Component: PurchaseOrderPage,
  path: '/dashboard/purchase-order/inbound-warehouse',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: purchaseOrderInboundWarehouseRBAC.pageID,
  isDashboard: true,
}

export const PurchaseOrderDetailRouter: RouterInstanceType = {
  name: 'PurchaseOrderDetailRouter',
  Component: PurchaseOrderDetailPage,
  path: '/dashboard/purchase-order/detail/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: purchaseOrderDetailRolesRBAC.pageID,
  isDashboard: true,
}

export const PurchaseOrderCheckQuantityRouter: RouterInstanceType = {
  name: 'PurchaseOrderCheckQuantityRouter',
  Component: PurchaseOrderCheckQuantity,
  path: '/dashboard/purchase-order/check-quantity/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: purchaseOrderCheckQuantityRBAC.pageID,
  isDashboard: true,
}

const PurchaseOrderRouter: RouterInstanceType[] = [
  DirectPutawayOldRouter,
  DirectPutawayRouter,
  DirectPutawayDetailRouter,
  InboundTaskRouter,
  InboundTaskDetailRouter,
  InboundTaskCheckQtyRouter,
  PurchaseOrderCreateRouter,
  PurchaseOrderInboundHubRouter,
  PurchaseOrderInboundWarehouseRouter,
  PurchaseOrderDetailRouter,
  PurchaseOrderCheckQuantityRouter,
]

export const PurchaseOrderRouterDetail = generateRouterDetail(PurchaseOrderRouter)

export default PurchaseOrderRouter
